"use strict";

exports.__esModule = true;
exports.TAB_SCOPE_POST_SETTINGS = void 0;
var TAB_SCOPE_POST_SETTINGS = 'post-settings';
exports.TAB_SCOPE_POST_SETTINGS = TAB_SCOPE_POST_SETTINGS;